import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-create-organisation',
  templateUrl: './create-organisation.component.html',
  styleUrls: ['./create-organisation.component.css']
})
export class CreateOrganisationComponent implements OnInit {


  @ContentChild('header') header!: TemplateRef<any>;
  @Output() businessName: EventEmitter<string> = new EventEmitter();
  @Input() canCancel: boolean = true;
  @Input() workspaceType: string = "Business";


  validator = new RegExp(/^[A-Za-z ]*$/);
  form: FormGroup = new FormGroup({
    businessNameRow: new UntypedFormControl(null, [Validators.required, Validators.pattern(this.validator)]),
  })

constructor(private snack: MatSnackBar) { }

ngOnInit(): void {

}

submit() {
  if (this.form.invalid) {
    this.snack.open("Form invalid", "dismiss", { duration: 3000 });
    return;
  } else
    this.businessName.emit(this.form.value.businessNameRow.trim());
}

}